import React from 'react';
import { Step, Icon } from 'semantic-ui-react';

import { POS_ROUTES } from 'PointOfSale/modules/common/constants';
import 'PointOfSale/styles/components/pageFooter.less';

const MealsTypesSideBar = props => {
  const { currentSelectedMenu, routes, history } = props;
  const { pathname } = routes;
  const isSelectedMealsTypes = pathname === POS_ROUTES.HOME;
  const isSelectedServeOptions = pathname === POS_ROUTES.SERVE_OPTIONS;

  return (
    <Step.Group fluid vertical>
      <Step
        // completed={currentSelectedMenu}
        active={isSelectedMealsTypes}
        link
        onClick={() => {
          currentSelectedMenu && history.push(POS_ROUTES.HOME);
        }}
      >
        <Icon name="coffee" />
        <Step.Content>
          <Step.Title>Meal Type</Step.Title>
          <Step.Description>
            Choose your meal type and serving items
          </Step.Description>
        </Step.Content>
      </Step>

      <Step
        disabled={!currentSelectedMenu}
        active={isSelectedServeOptions}
        link
        onClick={() => {
          currentSelectedMenu && history.push(POS_ROUTES.SERVE_OPTIONS);
        }}
      >
        <Icon name="edit" />
        <Step.Content>
          <Step.Title>Serving Option</Step.Title>
          <Step.Description>
            Choose your serving type and initial setup.
          </Step.Description>
        </Step.Content>
      </Step>
    </Step.Group>
  );
};

export default MealsTypesSideBar;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/layouts/component/pageSidebar/MealsTypesSideBar.js